export default __webpack_public_path__ + "static/media/group-632@3x.e22bd2c7.png";